import React from "react";
import { useNavigate } from "react-router-dom";
import SignIn from "./SignIn";
import { useAuthStatus } from "../hooks/useAuthStatus";

function Home() {
  const { currentUser } = useAuthStatus();
  const navigate = useNavigate();

  const doNavigate = () => {
    if (currentUser !== null) {
      navigate("/frontpage");
    } else {
      return <SignIn />;
    }
  };

  return (
    <>
      <div>{doNavigate()}</div>
    </>
  );
}

export default Home;
